import { ReactNode } from "react";
import { Paper, Stack, Text, Title } from "@mantine/core";

interface SectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
}

export function Section({ title, subtitle, children }: SectionProps) {
  return (
    <Paper withBorder p="md" radius="md" mb="lg">
      <Stack gap="sm">
        <div>
          <Title order={4}>{title}</Title>
          {subtitle ? (
            <Text size="xs" c="dimmed" mt={4}>
              {subtitle}
            </Text>
          ) : null}
        </div>
        {children}
      </Stack>
    </Paper>
  );
}
